/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseTeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/base-teaser-tile.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';

export const TeaserTileFragment = gql`
  ${BaseIconFragment}
  ${BaseImageFragment}
  ${BaseTeaserTileFragment}

  fragment TeaserTileFragment on TeaserTile {
    ...BaseTeaserTileFragment

    image {
      ...BaseImageFragment
    }
    overlayIcon {
      ...BaseIconFragment
    }
    descriptionCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
  }
`;
